import React from 'react';
import { ErrorLabel, ConversationPicker } from './components/components';
import { SuggestBoxWrapper, StatementText } from './layout/WrapperDiv';
import { infoWidth } from './components/constants';
import en from '../translationDefaults/en';
export const OrderConvoPick = ({
  value,
  options,
  handleConversationChange,
  error
}) => /*#__PURE__*/React.createElement(StatementText, {
  id: "verify-convo-check"
}, /*#__PURE__*/React.createElement(SuggestBoxWrapper, {
  width: infoWidth
}, en.convoType), /*#__PURE__*/React.createElement(ConversationPicker, {
  options: options,
  handleConversationChange: handleConversationChange,
  value: value
}), error && /*#__PURE__*/React.createElement(ErrorLabel, {
  errorLabel: error
}));
export default OrderConvoPick;